// Workaround for google translate issue (see https://github.com/facebook/react/issues/11538)
// Solution taken from https://github.com/facebook/react/issues/11538#issuecomment-417504600

// Whenever you see this in our logging: Please fix the underlying issue.
// If you start the app locally and use "google translate" you should see the origin of the error

import { getLogger } from './services/logger/logger'

if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild
  // @ts-ignore
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      getLogger('Google translation').info(
        'Google Translate bug: Cannot remove a child from a different parent. App is working but please fix the underlying issue',
        { path: window.location.href, affectedElement: { parent: this.textContent, child: child.textContent } }
      )
      if (console) {
        console.log('Affected element', child, this)
      }
      return child
    }
    // @ts-ignore
    return originalRemoveChild.apply(this, arguments)
  }

  const originalInsertBefore = Node.prototype.insertBefore
  // @ts-ignore
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      getLogger('Google translation').warn(
        'Google Translate bug: Cannot insert before a reference node from a different parent. App is working but please fix the underlying issue',
        {
          path: window.location.href,
          affectedElement: { parent: this.textContent, referenceNode: referenceNode.textContent },
        }
      )
      if (console) {
        console.log('Affected element', referenceNode, this)
      }

      return newNode
    }
    // @ts-ignore
    return originalInsertBefore.apply(this, arguments)
  }
}
export {}
